<dx-data-grid
  class="flex-1"
  [allowColumnReordering]="false"
  [remoteOperations]="{ paging: true }"
  [glamResource]="resource">

  <dxo-selection mode="none"></dxo-selection>

  <dxo-scrolling
    mode="virtual"
    rowRenderingMode="virtual"
    columnRenderingMode="standard">
  </dxo-scrolling>

  <dxi-column
    dataField="productCode"
    [caption]="'common.code' | translate | ucfirst"
    cellTemplate="productTemplate">
  </dxi-column>

  <div *dxTemplate="let cell of 'productTemplate'">
    <div class="d-flex align-items-center">
          <span class="tree-depth dx-theme-accent-as-text-color d-flex" style="font-size: 8px; margin-right: 6px; letter-spacing: 2px">
            <span
              *ngFor="let i of [].constructor(cell.data.depth ?? 0)"
              class="me-2"
            >
              ◉
            </span>
          </span>
      <strong>{{ cell.data.productCode }}</strong>
      <span class="hover:underline cursor-pointer ms-2"
            (click)="openProduct(cell.data)">
            {{ cell.data.productName }}
          </span>
    </div>
  </div>

  <dxi-column
    dataField="processSheetName"
    cellTemplate="processSheetTemplate"
    [caption]="'entity.productionOrder.processSheetId' | translate | ucfirst">
    <div *dxTemplate="let cell of 'processSheetTemplate'">
           <span class="hover:underline cursor-pointer ms-2"
                 (click)="openProcessSheet(cell.data)">
            {{ cell.data.processSheetName }}
          </span>
    </div>
  </dxi-column>

  <dxi-column
    dataField="processSheetVersion"
    [caption]="'entity.processSheet.version' | translate | ucfirst">
  </dxi-column>

  <dxi-column
    dataField="revisionDate"
    dataType="date"
    [caption]="'common.signature' | translate | ucfirst">
  </dxi-column>

  <dxi-column
    dataField="standardCost"
    [format]="{
          type: 'currency',
          precision: (currency?.decimals ? currency?.decimals : 2),
          currency: (currency?.code ? currency?.code : 'EUR')
        }"
    [caption]="'entity.standardCost' | translate | ucfirst">
  </dxi-column>
</dx-data-grid>
